// extracted by mini-css-extract-plugin
module.exports = {"articles-wrapper":"_9e1425b4d3--articles-wrapper--hRmAa"};